<template>
  <div>
    <el-row style="height: 40px">
      <el-col :span="24">
        <el-button type="primary" size="small" @click="showImport=true" style="margin-right: 15px">导入订单</el-button>
        订单号：<el-input v-model="tid" size="mini" style="width: 180px"></el-input>
        <el-button type="primary" size="small" @click="getOuterData" style="margin-right: 15px">搜索</el-button>
        <span></span>
      </el-col>
    </el-row>

    <div class="block" align="left" style="margin-left: 400px; color: #000">

      <span class="demonstration"></span>
      <el-pagination style="color: #000"
                     @size-change="handleSizeChange"
                     @current-change="handleCurrentChange"
                     :current-page="pageObject.pageCurrent"
                     :page-sizes="[10, 50, 100, 500, 1000, 2000, 5000]"
                     :page-size="pageObject.pageSize"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="pageObject.rowCount">
      </el-pagination>
    </div>


    <el-row>
      <el-col :span="24">
        <el-table border style="font-size: 12px" :data="outerData" :header-cell-style="{background:'#F2F6FC',color:'#000'}" :cell-style="{padding: '0px'}">
          <el-table-column  label="ID"
                            type="index"
                            :index="indexMethod">
          </el-table-column>
          <el-table-column  prop="tid" label="订单号" width="200px"></el-table-column>
          <el-table-column  prop="status" label="订单状态" width="200px"></el-table-column>

          <el-table-column  prop="created" label="拍下时间" width="200px"></el-table-column>
          <el-table-column  prop="payTime" label="付款时间" width="200px"></el-table-column>
        </el-table>
      </el-col>
    </el-row>

    <el-dialog
      title="导入数据" :close-on-click-modal="false"
      :visible.sync="showImport"
      width="80%"
      center>
      <span style="margin-left:20px; margin-bottom: 30px">复制Excel表格里的订单（直接全选复制），在这里粘贴</span>
      <el-input :rows="20" type="textarea" v-model="logisTxt" > </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showImport = false">取 消</el-button>
        <el-button type="primary" @click="uploadData">确 定</el-button>
      </span>
    </el-dialog>



  </div>
</template>

<script>
  import $api from "../api/axios";
  import storage from "../api/storage"
  import {hideLoading, showLoading} from "../api/loading";

  export default {
    name: "Outer",
    data(){
      return{
        deny:0,
        showImport:false,
        showCompany:false,
        status:'WAIT_SELLER_SEND_GOODS',
        logisTxt:'',
        outerData:[],
        tid:'',
        pageObject: {
          pageCurrent: 1,
          rowCount: 0,
          pageSize: 50,
        },

      }
    },
    methods:{
      indexMethod(index)
      {
        return index + 1;
      },
      //改变pageSize
      handleSizeChange: function (val) {
        this.pageObject.pageSize = val;
        this.getOuterData();
      },
      //当前页面改变
      handleCurrentChange: function (val) {
        this.pageObject.pageCurrent = val;
        this.getOuterData();
      },
      getOuterData:function () {
        let param={
          nick:storage.get("nick"),
          tid: this.tid,
          pageCurrent: this.pageObject.pageCurrent,
          rowCount: this.pageObject.rowCount,
          pageSize: this.pageObject.pageSize,
        }
        $api.post("/outer/get", param, response =>{
          let dataResult = response.data;
          console.log(dataResult)
          if (dataResult.state == 1 && dataResult.message == "ok"){
            this.outerData = dataResult.data.outer;


            let pageObject = dataResult.data.pageObject;
            this.pageObject.rowCount = pageObject.rowCount;
            this.pageObject.pageSize = pageObject.pageSize;
          }
          else{
            this.$message.error(dataResult);
            //this.$router.replace({name: "Index"});
            this.deny = 1;
          }
        })
        hideLoading();
      },
      uploadData:function () {
        this.showImport = false;
        if(this.deny == 1){
          this.$message.error("您没有该权限, 请联系主号分配权限。");
          return;
        }
        let txt = '';
        let txtArr = this.logisTxt.split('\n');
        let title = txtArr[0] + '\n';
        if (txtArr.length <= 300){
          txt = this.logisTxt;
        }else{
          let i = 0;
           while(i<txtArr.length){
             txt += txtArr[i] + "\n";
             i++;
             if(i % 300 == 0){
               //后面的行需要加上 title
               if(i>300){
                 txt = title + txt;
               }
               this.postData(txt);
               txt = '';
             }
           }
        }
        //不足300时
        txt = title + txt;
        this.postData(txt);
      },

      postData:function (txt) {
        let param={
          nick:storage.get("nick"),
          txt: txt
        }
        $api.post("/outer/import", param, response =>{
          console.log(response)
          let dataResult = response.data;
          if (dataResult.state == 1 && dataResult.message == "ok"){
            this.logisTxt = '';
            this.getOuterData();
            console.log("end.")   //批注 形容词
            this.$message.warning("导入成功后，去显示数据里，点批量明文就可以了！")
          }
          else{
            this.$message.error(dataResult.data.message);
          }
        })

      }



    },
    mounted(){
      this.getOuterData();
    }
  }
</script>

<style >


</style>



// WEBPACK FOOTER //
// src/page/Outer.vue